import React from 'react';
import {
  Popover,
  Box,
  Typography,
  Button,
  List,
  ListItem,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from '@mui/material';

const ClientCityFilterPopover = ({
  open,
  anchorEl,
  onClose,
  cities,
  isLoading,
  selectedCities,
  onToggleCity,
  onSelectAll,
  onClearAll,
  allSelected,
  anySelected,
}) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    PaperProps={{ sx: { mt: 0.5 } }}
  >
    <Box sx={{ p: 2, minWidth: 280, maxWidth: 360 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          Miasto
        </Typography>
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Button
            size="small"
            onClick={onClearAll}
            disabled={!anySelected}
            sx={{ textTransform: 'none' }}
          >
            Wyczyść filtr
          </Button>
          <Button
            size="small"
            onClick={onSelectAll}
            disabled={allSelected || !cities.length}
            sx={{ textTransform: 'none' }}
          >
            Wszystkie
          </Button>
        </Box>
      </Box>
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
          <CircularProgress size={24} />
        </Box>
      ) : cities.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
          Brak miast do filtrowania.
        </Typography>
      ) : (
        <List dense disablePadding sx={{ maxHeight: 360, overflow: 'auto' }}>
          {cities.map(({ city, count }) => (
            <ListItem key={city} disablePadding sx={{ py: 0 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={selectedCities.has(city)}
                    onChange={() => onToggleCity(city)}
                  />
                }
                label={
                  <Typography variant="body2">
                    {city} ({count})
                  </Typography>
                }
                sx={{ width: '100%', m: 0, py: 0.25, px: 0.5 }}
              />
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  </Popover>
);

export default ClientCityFilterPopover;
